import { useLocale } from 'shared/library/i18n/use-locale';
import { useMemo } from 'react';
import { staticImage } from 'shared/library/static-images';
import type { MediaImageSource } from 'shared/library/media-image-versions';

export type PartnerInfo = {
  countryCode: string;
  name: string;
  image: MediaImageSource;
  url: string;
};

export const insurancePartners: (PartnerInfo & {
  dogInsuranceUrl: string;
  catInsuranceUrl: string;
})[] = [
  {
    countryCode: 'SE',
    name: 'Trygg-Hansa',
    image: staticImage('trygg-hansa-logo'),
    url: 'https://www.trygghansa.se/',
    dogInsuranceUrl:
      'https://www.trygghansa.se/djurforsakring/hundforsakring/berakna-pris?utm_source=skaffahund&utm_medium=display&utm_campaign=hudforsakring2024&utm_content=skaffahund',
    catInsuranceUrl:
      'https://www.trygghansa.se/djurforsakring/kattforsakring/berakna-pris?utm_source=skaffahund&utm_medium=display&utm_campaign=hudforsakring2024&utm_content=skaffahund',
  },
  {
    countryCode: 'NO',
    name: 'Tryg',
    image: staticImage('tryg-logo'),
    url: 'https://www.tryg.no/',
    dogInsuranceUrl: 'https://www.tryg.no/forsikringer/dyr/hundeforsikring',
    catInsuranceUrl: 'https://www.tryg.no/forsikringer/dyr/katteforsikring',
  },
];

const defaultInsurancePartner =
  insurancePartners.find((partner) => partner.countryCode === 'SE') ?? insurancePartners[0]!;

export const shopPartners: PartnerInfo[] = [
  {
    countryCode: 'SE',
    name: 'Arken Zoo',
    image: staticImage('arken-zoo-logo'),
    url: 'https://www.arkenzoo.se/',
  },
  {
    countryCode: 'NO',
    name: 'Musti',
    image: staticImage('musti-logo'),
    url: 'https://www.musti.no/',
  },
  {
    countryCode: 'FI',
    name: 'Musti ja Mirri',
    image: staticImage('musti-fi-logo'),
    url: 'https://www.mustijamirri.fi/',
  },
  {
    countryCode: 'DK',
    name: 'Maxi Zoo',
    image: staticImage('maxi-zoo-logo'),
    url: 'https://www.maxizoo.dk/',
  },
];

export const usePartners = () => {
  const { countryCode } = useLocale();

  const insurancePartner = useMemo(
    () =>
      insurancePartners.find((partner) => partner.countryCode === countryCode) ??
      defaultInsurancePartner,
    [countryCode],
  );

  const shopPartner = useMemo(
    () => shopPartners.find((partner) => partner.countryCode === countryCode)!,
    [countryCode],
  );

  return { insurancePartner, shopPartner };
};
